import React from 'react';

import RouterTabs from '../../../../components/tabs/RouterTabs';

function renderTabsWithRouterBlock(data, index, renderStaticSection) {
  const {
          CONTENT           = [],
          LABEL,
          NAV               = [],
          STYLE,
          TITLE,
          URL               = [],
          TABS_ROUTER_LEVEL = 1,
        } = data;

  return (
    <section key={index} className={'withTabs multi'}>
      <div className={'container'}>
        {typeof TITLE === 'string' && TITLE.length > 0 && (
          <h2>{TITLE}</h2>
        )}
        <RouterTabs
          content={CONTENT}
          label={LABEL}
          nav={NAV}
          renderStaticSection={renderStaticSection}
          style={STYLE}
          tabsRouterLevel={TABS_ROUTER_LEVEL}
          url={URL}
        />
      </div>
    </section>
  );
}

export default renderTabsWithRouterBlock;